import { React, CheckIcon, CircleAlertIcon, InfoIcon, XIcon } from '../vendor/runtime.js';

export function notify(message, type = 'success', title) {
  window.dispatchEvent(new CustomEvent('codebruh:notification', { detail: { message, type, title } }));
}
export function Toast({ show, onClose, message, type = 'success', title }) {
  const [paused, setPaused] = React.useState(false);
  React.useEffect(() => {
    if (!show || paused || type === 'error') return;
    const timer = setTimeout(() => onClose?.(), 6000);
    return () => clearTimeout(timer);
  }, [show, message, paused, type, onClose]);
  if (!show) return null;
  const Icon = type === 'success' ? CheckIcon : type === 'error' ? CircleAlertIcon : InfoIcon;
  return <div className={`cb-toast cb-toast-${type}`} role={type === 'error' ? 'alert' : 'status'}
    onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
    onFocus={() => setPaused(true)} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setPaused(false); }}>
    <span className="cb-toast-icon"><Icon aria-hidden="true" /></span>
    <div className="cb-toast-copy"><strong>{title || (type === 'success' ? 'Success' : type === 'error' ? 'Something went wrong' : 'Information')}</strong><p>{message}</p></div>
    <button type="button" className="cb-icon-button" onClick={onClose} aria-label="Dismiss notification"><XIcon /></button>
  </div>;
}
export function NotificationHost() {
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    let serial = 0;
    const receive = event => setItems(previous => [...previous, { ...event.detail, id: ++serial }]);
    window.addEventListener('codebruh:notification', receive);
    return () => window.removeEventListener('codebruh:notification', receive);
  }, []);
  const dismiss = React.useCallback(() => setItems(previous => previous.slice(1)), []);
  return items[0] ? <Toast key={items[0].id} show {...items[0]} onClose={dismiss} /> : null;
}
